import * as React from 'react';
import Divider from './divider';

export interface FullDescriptionLinkProps {
    title?: string;
    description?: string;
    image?: any;
    style?: React.CSSProperties
}

export interface FullDescriptionLinkState {

}

export default class FullDescriptionLink extends React.Component<FullDescriptionLinkProps, FullDescriptionLinkState> {
  constructor(props: FullDescriptionLinkProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    return (
      <div className="full-description-link" style={this.props.style}>
            <div className="image-container">
                <img src={this.props.image}/>
            </div>
            <Divider size="x-small"/>
            <h3>{this.props.title}</h3>
            <p>{this.props.description}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/full-description-link.tsx